import { Accordion, AccordionDetails, AccordionSummary } from '@mui/material'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import {
  Datagrid,
  EditButton,
  FunctionField,
  List,
  TextField,
} from 'react-admin'
import PropTypes from 'prop-types'

const RulesAccordion = ({ collectionAgentId }) => {
  return (
    <Accordion sx={{ mt: 2 }}>
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls="rules-content"
        id="rules-header"
      >
        <h3>Rule Sets</h3>
      </AccordionSummary>
      <AccordionDetails sx={{ pt: 0, mt: -5 }}>
        <List
          basePath="/rules"
          resource="rules"
          hasEdit={true}
          hasCreate={false}
          exporter={false}
          filter={{ 'collectionAgent.id': collectionAgentId }}
          perPage={999}
        >
          <Datagrid>
            <TextField source="name" />
            <TextField source="matchType" />
            <TextField source="type" />
            <FunctionField
              label="Price Adjustment"
              render={(record) =>
                record?.type === 'price_adjustment'
                  ? record.ruleSetAdjustments[0]?.value
                  : 'N/A'
              }
            />
            <EditButton target="_blank" />
          </Datagrid>
        </List>
      </AccordionDetails>
    </Accordion>
  )
}

RulesAccordion.propTypes = {
  collectionAgentId: PropTypes.number.isRequired,
}

export default RulesAccordion
